import { render, staticRenderFns } from "./QuotationsCarrier.vue?vue&type=template&id=b26cb60a&"
import script from "./QuotationsCarrier.vue?vue&type=script&lang=js&"
export * from "./QuotationsCarrier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports